const fundamentalZone = [
  {
    path: "/unlocked-promotor",
    name: "UnlockedPromotors",
    component: () => import("src/pages/Fundamental/UnlockedPromotors.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/fundamental-scan",
    name: "FundamantalScan",
    component: () => import("src/pages/Fundamental/FundamentalScan.vue"),
    meta: authRequired(),
  },
  {
    path: "/fundamental-scan-pro",
    name: "FundamentalScanPro",
    component: () => import("src/pages/Fundamental/FundamentalScanPro.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/stock-comparison",
    name: "StockComparison",
    component: () => import("src/pages/Fundamental/StockComparison.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/stock-comparison-all",
    name: "StockComparisionAll",
    component: () => import("src/pages/Fundamental/StockComparisionAll.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/trading-below-fair-value",
    name: "TradingBelowFairValue",
    component: () => import("src/pages/Fundamental/TradingBelowFairValue.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/low-cap-company",
    name: "LowCapCompany",
    component: () => import("src/pages/Fundamental/LowCapCompany.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/float-cap-company",
    name: "CapFilter",
    component: () => import("src/pages/Fundamental/FloatCap.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/dividend-history-comparison",
    name: "DividendHistoryComparison",
    component: () =>
      import("src/pages/Fundamental/DividendHistoryComparison.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/dividend-history",
    name: "DividendHistory",
    component: () => import("src/pages/Fundamental/DividendHistory.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/growth-above-40-percent",
    name: "GrowthAbove40Percent",
    component: () => import("src/pages/Fundamental/GrowthAbove40Percent.vue"),
    meta: { requiresAuth: false },
  },
];
const utilityZone = [
  {
    path: "share-calculator",
    name: "ShareCalculator",
    component: () => import("src/pages/ShareCalculator/ShareCalculator.vue"),
    meta: authRequired(),
  },

  {
    path: "/consolidating-up-breakout",
    name: "ConsolidatingUpBreakout",
    component: () => import("src/pages/ConsolidatingUpBreakout.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/consolidating-down-breakout",
    name: "ConsolidatingDownBreakout",
    component: () => import("src/pages/ConsolidatingDownBreakout.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/insidebar-up-breakout",
    name: "InsidebarUpBreakout",
    component: () => import("src/components/Breakout/InsidebarUpBreakout.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/insidebar-down-breakout",
    name: "InsidebarDownBreakout",
    component: () =>
      import("src/components/Breakout/InsidebarDownBreakout.vue"),
    meta: { requiresAuth: false },
  },

  {
    path: "/trending-stocks",
    name: "TrendingStocks",
    component: () => import("src/pages/TrendingStocks.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/consolidating-stocks",
    name: "ConsolidatingStocks",
    component: () => import("src/pages/ConsolidatingStocks.vue"),
    meta: { requiresAuth: false },
  },

  {
    path: "/volatile-stocks",
    name: "VolatileStocks",
    component: () => import("src/pages/VolatileStocks.vue"),
    meta: { requiresAuth: false },
  },

  {
    path: "/value-at-risk",
    name: "ValueAtRisk",
    component: () => import("src/pages/ValueAtRisk.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/trading-near-52-weeks",
    name: "TradingNear52Week",
    component: () => import("src/pages/TradingNear52Week.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/trading-below-120-days-average",
    name: "TradingBelow120DaysAverage",
    component: () => import("src/pages/TradingBelow120DaysAverage.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/custom-signal",
    name: "CustomSignalPage",
    component: () => import("src/pages/CustomSignalPage.vue"),
    meta: { requiresAuth: false },
  },
];
const routes = [
  {
    path: "/",
    component: mainLayout(),
    children: [
      {
        path: "/",
        name: "Dashboard",
        component: dashboardPage(),
        meta: authRequired(),
      },
      {
        path: "fav-menu",
        name: "FavouriteMenu",
        component: () => import("src/pages/FavouriteMenu.vue"),
        meta: authRequired(),
      },

      {
        path: "/chukul-ten",
        name: "ChukulTen",
        component: () => import("src/pages/ChukulTen.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/sector-performance",
        name: "SectorPerformance",
        component: () => import("src/pages/SectorPerformance.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/stock-performance",
        name: "StockPerformance",
        component: () => import("src/pages/StockPerformance.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/market-cap",
        name: "MarketCap",
        component: () => import("src/pages/MarketCap/MarketCap.vue"),
        meta: { requiresAuth: false },
      },

      {
        path: "/ipo-auction",
        name: "IposAndAuction",
        component: () => import("src/pages/IposAndAuction/IposAndAuction.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/stock-filter",
        name: "StockFilter",
        component: () => import("src/pages/StockFilter.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/chukul-manual",
        name: "ChukulManual",
        component: () => import("src/pages/ChukulManual.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/promoter-bidding",
        name: "PromoterBidding",
        component: () =>
          import("src/pages/PromoterBidding/PromoterBidding.vue"),
        meta: { requiresAuth: false },
      },

      {
        path: "/mutual-fund-matrix",
        name: "MutualFundMatrix",
        component: () => import("src/pages/MutualFund/MutualFundMatrix.vue"),
        meta: authRequired(),
      },
      {
        path: "/mutual-fund-top-holding",
        name: "MutualFundTopHolding",
        component: () =>
          import("src/pages/MutualFund/MutualFundTopHolding.vue"),
        meta: authRequired(),
      },
      {
        path: "/custom-signal-pro",
        name: "CustomSignalPro",
        component: () =>
          import("src/pages/CustomSignal/CustomSignalPro/CustomSignalPro.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/custom-signal-pro-v2",
        name: "CustomSignalProV2",
        component: () =>
          import(
            "src/pages/CustomSignal/CustomSignalProV2/CustomSignalProRun.vue"
          ),
        meta: { requiresAuth: false },
      },
      {
        path: "/custom-signal-pro-save",
        name: "CustomSignalProSave",
        component: () =>
          import(
            "src/pages/CustomSignal/CustomSignalProV2/CustomSignalProSave.vue"
          ),
        meta: { requiresAuth: false },
      },

      {
        path: "/custom-signal-pro-results",
        name: "CustomSignalProV2Results",
        component: () =>
          import(
            "src/pages/CustomSignal/CustomSignalProV2/CustomSignalProResults.vue"
          ),
        meta: { requiresAuth: false },
      },
      {
        path: "/portfolio",
        name: "PortfolioPage",
        component: () => import("pages/Portfolio.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/my-portfolio",
        name: "MyPortfolio",
        component: () => import("pages/MyPortfolio.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/nepse-market-summary",
        name: "NepseMarketSummary",
        component: nepseMarketSummaryPage(),
        meta: authRequired(),
      },
      {
        path: "/custom-market-summary",
        name: "CustomNepseMarketSummary",
        component: () =>
          import("pages/MarketZone/CustomNepseMarketSummary.vue"),
        meta: authRequired(),
      },
      {
        path: "/ltp-vs-close",
        name: "LtpVsClose",
        component: () => import("pages/MarketZone/LtpVsClose.vue"),
        meta: authRequired(),
      },
      {
        path: "/nepse-live-market",
        name: "NepseLiveMarket",
        component: () =>
          import("src/pages/NepseLiveMarket/NepseLiveMarket.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/live-market",
        name: "LiveMarket",
        component: () => import("src/pages/NepseLiveMarket.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/live-chart",
        name: "liveChart",
        component: () => import("src/pages/Theme/LiveChart/LiveChart.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/sector-chart",
        name: "SectorChart",
        component: () => import("src/pages/Theme/SectorChart/SectorChart.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/today-floorsheet",
        name: "TodayFloorsheet",
        component: () => import("src/pages/TodayFloorsheet.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/today-floorsheet",
        name: "TodayFloorsheetV1",
        component: () => import("src/pages/TodayFloorsheet.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/floorsheet",
        name: "TodayFloorsheet",
        component: () => import("src/pages/TodayFloorsheetV2.vue"),
        meta: authRequired(),
      },
      {
        path: "/brokers-analytics",
        name: "BrokerAnalytics",
        component: brokerAnalyticsPage(),
        meta: authRequired(),
      },
      {
        path: "/broker-analytics-intraday",
        name: "BrokerAnalyticsIntraday",
        component: () =>
          import("src/pages/BrokerAnalytics/BrokerAnalyticsIntraday.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/broker-transaction",
        name: "BrokerTransaction",
        component: () =>
          import("src/pages/BrokerTransaction/BrokerTransaction.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/broker-transactions",
        name: "BrokerTransactionNew",
        component: () =>
          import("src/pages/BrokerTransaction/BrokerTransactionNew.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/broker-holding",
        name: "BrokerHolding",
        component: () =>
          import("src/pages/BrokerTransaction/BrokerHolding.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/tree-map",
        name: "TreeMap",
        component: () => import("src/pages/TreeMap/TreeMap.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/net-holding",
        name: "NetHolding",
        component: () => import("src/pages/NetHolding/NetHolding.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/broker-favourite",
        name: "BrokerFavourite",
        component: () =>
          import("src/pages/BrokerFavourite/BrokerFavourite.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/selected-individual-holding",
        name: "SelectedIndividualHoldings",
        component: () =>
          import(
            "src/pages/SelectedIndividualHoldings/SelectedIndividualHoldings.vue"
          ),
        meta: { requiresAuth: false },
      },
      {
        path: "/broker-summary",
        name: "BrokerSummary",
        component: () => import("src/pages/BrokerSummary.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/brokers-analytics-pro",
        name: "BrokerAnalyticsPro",
        component: () => import("src/pages/BrokerAnalyticsPro.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/top-broker-top-holding",
        name: "TopBrokerTopHolding",
        component: () => import("pages/TopBrokerTopHolding.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/top-broker-top-released",
        name: "TopBrokerTopReleased",
        component: () => import("pages/TopBrokerTopReleased.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/sector-wise-top-stocks",
        name: "SectorWiseTopStocksPage",
        component: () => import("src/pages/SectorWiseTopStocksPage.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/sector-profile",
        name: "SectorProfile",
        component: () => import("pages/SectorProfile.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/key-value-alert",
        name: "KeyValueAlert",
        component: () => import("src/pages/KeyValueAlertPage.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/stock-profile",
        name: "StockProfile",
        component: stockProfilePage(),
        meta: authRequired(),
      },
      {
        path: "/user-profile",
        name: "UserProfile",
        component: () => import("src/pages/UserProfile.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/notifications",
        name: "NotificationUser",
        component: () => import("src/pages/NotificationPage.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/notifications-user",
        name: "UserNotification",
        component: () => import("src/pages/Notification/UserNotification.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/notifications-general",
        name: "GeneralNotification",
        component: () => import("src/pages/NotificationPageGeneral.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/announcement",
        name: "AnnouncementNews",
        component: () => import("src/pages/AnnouncementNews.vue"),
        meta: { requiresAuth: false },
      },

      {
        path: "/my-signals",
        name: "MySignals",
        component: () => import("src/pages/MySignals.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/today-signal",
        name: "SignalPage",
        component: () => import("src/pages/TodaySignal.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/daily-signal",
        name: "DailySignal",
        component: () => import("src/pages/DailySignal.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/weekly-signal",
        name: "WeeklySignal",
        component: () => import("src/pages/WeeklySignal.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/mean-reversal-signal",
        name: "MeanReversalSignal",
        component: () =>
          import("src/pages/TradingSignalsAndTypes/MeanReversalSignal.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/momentum-breakout",
        name: "MomentumTradingSignals",
        component: () =>
          import("src/pages/TradingSignalsAndTypes/MomentumTradingSignals.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/divergence",
        name: "Divergence",
        component: () =>
          import("src/pages/TradingSignalsAndTypes/Divergence.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/intraday-signal",
        name: "intradaySignalPage",
        component: () => import("src/pages/IntradaySignal.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/settings",
        name: "Settings",
        component: () => import("src/pages/Settings.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/candlestick-pattern",
        name: "candleStickPattern",
        component: () => import("src/pages/CandleStickPattern.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/price-action-signals",
        name: "PriceActionSignals",
        component: () =>
          import("src/pages/TradingSignalsAndTypes/PriceActionSignals.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/dow-signals",
        name: "DowSignals",
        component: () => import("src/pages/TradingSignalsAndTypes/DowSignal.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/candlestick-identificaton",
        name: "CandlestickIdentificaton",
        component: () => import("src/pages/CandlestickIdentificaton.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/back-test-engine",
        name: "BackTestEngine",
        component: () => import("src/pages/BackTestEngine.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/market-summary",
        name: "MarketSummaryPage",
        component: () => import("src/pages/MarketSummaryPage.vue"),
      },
      ...utilityZone,
      {
        path: "/sector-report",
        name: "SectorReportPage",
        component: () => import("src/pages/SectorReportPage.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/live-strong-buy-sell",
        name: "LiveStrongBuySellList",
        component: () =>
          import("src/pages/CircuitSetup/LiveStrongBuySellList.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/live-weak-buy-sell",
        name: "LiveWeakBuySellList",
        component: () =>
          import("src/pages/CircuitSetup/LiveWeakBuySellList.vue"),
        meta: { requiresAuth: false },
      },
      ...fundamentalZone,
      {
        path: "/chukul-performance",
        name: "ChukulPerformance",
        component: () => import("src/pages/ChukulPerformance.vue"),
        meta: { requiresAuth: false },
      },

      {
        path: "/video-tutorial",
        name: "VideoTutorial",
        component: () => import("src/pages/VideoTutorial/VideoTutorial.vue"),
      },
      {
        path: "/quiz",
        name: "QuestionAnswer",
        component: () => import("src/pages/Quiz/QuestionAnswer.vue"),
      },
      {
        path: "/trend-filter",
        name: "TrendFilter",
        component: () => import("src/pages/CircuitSetup/TrendFilter.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/consolidating-stocks",
        name: "ConsolidatingStocks",
        component: () =>
          import("src/pages/TechnicalZone/ConsolidatingUpperLower.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/live-volume-spike",
        name: "LiveVolumeSpike",
        component: () => import("src/pages/TechnicalZone/LiveVolumeSpike.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/live-dow",
        name: "LiveDow",
        component: () => import("src/pages/TechnicalZone/LiveDow.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/live-macd-cross",
        name: "LiveMacdCross",
        component: () => import("src/pages/TechnicalZone/LiveMacdCross.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/live-hot-stock",
        name: "LiveHotStock",
        component: () => import("src/pages/CircuitSetup/LiveHotStock.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/circuit-setup",
        name: "CircuitSetup",
        component: () => import("src/pages/CircuitSetup/CircuitSetup.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/live-volatile-stock",
        name: "LiveVolatileStock",
        component: () => import("src/pages/CircuitSetup/LiveVolatileStock.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/probable-circuit-setup-transaction",
        name: "ProbableCircuitSetup",
        component: () =>
          import("src/pages/CircuitSetup/ProbableCircuitSetup.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/live-bulk-tnx",
        name: "LiveBulkTransaction",
        component: () =>
          import("src/pages/CircuitSetup/LiveBulkTransaction.vue"),
      },
      {
        path: "/live-bulk-transaction-with-market",
        name: "LiveBulkTransactionWithMarket",
        component: () =>
          import("src/pages/CircuitSetup/LiveBulkTransactionWithMarket.vue"),
      },
      {
        path: "/live-bulk-transaction-with-market-buy-sell",
        name: "LiveBulkTransactionWithMarketBuySell",
        component: () =>
          import(
            "src/pages/CircuitSetup/LiveBulkTransactionWithMarketBuySell.vue"
          ),
      },
      {
        path: "/bulk-tnx-pro",
        name: "BulkTransactionPro",
        component: () =>
          import("src/pages/CircuitSetup/BulkTransactionPro.vue"),
      },
      {
        path: "/bulk-tnx-days",
        name: "BulkTransactionDayswise",
        component: () =>
          import("src/pages/BulkTransactionZone/BulkTransactionDayswise.vue"),
      },
      {
        path: "/player-favourite-days",
        name: "PlayerFavouriteDays",
        component: () =>
          import("src/pages/BulkTransactionZone/PlayerFavouriteDays.vue"),
      },
      {
        path: "/player-favourite-transaction",
        name: "PlayerFavourite",
        component: () => import("src/pages/CircuitSetup/PlayerFavourite.vue"),
      },
      {
        path: "/player-favourite-pro",
        name: "PlayerFavouritePro",
        component: () =>
          import("src/pages/CircuitSetup/PlayerFavouritePro.vue"),
      },
      {
        path: "/player-choice",
        name: "PlayerChoice",
        component: () => import("src/pages/PlayerFavourite/PlayerChoice.vue"),
      },
      {
        path: "/bulk-tnx-circuit-setup",
        name: "BulkTnxCircuitSetup",
        component: () =>
          import("src/pages/CircuitSetup/BulkTnxCircuitSetup.vue"),
      },
      {
        path: "/sector-sentiment",
        name: "SectorSentiment",
        component: () => import("src/pages/CircuitSetup/SectorSentiment.vue"),
      },
      {
        path: "/accumulation-distribution",
        name: "AccumulationDistribution",
        component: () =>
          import(
            "src/pages/AccumulationDistribution/AccumulationDistribution.vue"
          ),
      },
    ],
  },
  // TMS
  {
    path: "/",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "tms-register",
        name: "TmsRegister",
        component: () => import("src/pages/TMS/TmsRegister.vue"),
        meta: { requiresAuth: false },
        // meta: authRequired(),
      },
      {
        path: "tms-login",
        name: "TmsLogin",
        component: () => import("src/pages/TMS/TmsLogin.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "tms-watchlist",
        name: "TmsAddWatchlist",
        component: () => import("src/pages/TMS/AddWatchlist.vue"),
        meta: { requiresAuth: false },
        // meta: authRequired(),
      },
      {
        path: "tms-auto-buy-sell",
        name: "AutoBuySell",
        component: () => import("src/pages/TMS/TMSAutoBuySell.vue"),
        meta: { requiresAuth: false },
        // meta: authRequired(),
      },
      {
        path: "tms-market-depth",
        name: "TmsMarketDepth",
        component: () => import("src/pages/TMS/TmsMarketDepth.vue"),
        meta: { requiresAuth: false },
        // meta: authRequired(),
      },
    ],
  },

  {
    path: "/",
    component: infoLayout(),
    children: [
      {
        path: "/demo-login",
        name: "ArthaSarokarLogin",
        component: () => import("src/pages/Theme/Theme2Login.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/privacy-policy",
        name: "PrivacyPolicy",
        component: () => import("pages/PrivacyPolicy.vue"),
      },
      {
        path: "/privacy",
        name: "Privacy",
        component: () => import("src/pages/PrivacyAndPolicy.vue"),
      },
      {
        path: "/terms-and-condition",
        name: "TermsCondition",
        component: () => import("pages/TermsCondition.vue"),
      },
      {
        path: "/terms-and-conditions",
        name: "TermsConditions",
        component: () => import("pages/TermsConditions.vue"),
      },
      {
        path: "/disclaimer",
        name: "DisclaimerPage",
        component: () => import("src/pages/DisclaimerPage.vue"),
      },
      {
        path: "/two-charts-layout",
        name: "TwoChartsLayout",
        component: () => import("src/pages/ChartLayout/TwoChartsLayout.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/three-charts-layout",
        name: "ThreeChartsLayout",
        component: () => import("src/pages/ChartLayout/ThreeChartsLayout.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/four-charts-layout",
        name: "FourChartsLayout",
        component: () => import("src/pages/ChartLayout/FourChartsLayout.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/five-charts-layout",
        name: "FiveChartsLayout",
        component: () => import("src/pages/ChartLayout/FiveChartsLayout.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/six-charts-layout",
        name: "SixChartsLayout",
        component: () => import("src/pages/ChartLayout/SixChartsLayout.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/multiple-layout/:layout",
        name: "MultipleLayout",
        component: () => import("src/pages/ChartLayout/MultipleLayout.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/faq",
        name: "FAQs",
        component: () => import("src/pages/FAQ.vue"),
      },
      {
        path: "/contact-us",
        name: "contactUs",
        component: () => import("src/pages/ContactUs/contactus.vue"),
      },
      {
        path: "/feedback",
        name: "ReportBug",
        component: () => import("src/pages/Feedback.vue"),
      },
      {
        path: "/jira",
        name: "JiraReplica",
        component: () => import("pages/JiraReplica.vue"),
      },
      {
        path: "/login",
        name: "Login",
        component: loginPage(),
      },
      {
        path: "/signup",
        name: "Signup",
        component: () => import("pages/Signup.vue"),
      },
      {
        path: "/reset",
        name: "Reset",
        component: () => import("pages/Reset.vue"),
      },
      {
        path: "/tms-privacy-and-policy",
        name: "PrivacyAndPolicy",
        component: () => import("src/pages/TMS/PrivacyAndPolicy.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/tms-terms-and-condition",
        name: "TermsAndCondition",
        component: () => import("src/pages/TMS/TermsAndCondition.vue"),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/",
    component: () => import("layouts/BasicLayout.vue"),
    children: [
      {
        path: "/",
        name: "LandingPage",
        component: () => import("pages/LandingPage.vue"),
        meta: { requiresAuth: false },
      },
    ],
  },
  {
    path: "/payment",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        name: "Payment",
        component: () => import("src/pages/Membership.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "ios",
        name: "PaymentIos",
        component: () => import("src/pages/MembershipIos.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "providers",
        name: "PaymentProvider",
        component: () => import("src/pages/PaymentProvider.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "success",
        name: "PaymentSuccess",
        component: () => import("src/pages/PaymentSuccess.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "failure",
        name: "PaymentFailure",
        component: () => import("src/pages/PaymentFailure.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "esewa/pending",
        name: "PaymentPending",
        component: () => import("src/pages/PaymentPending.vue"),
        meta: { requiresAuth: false },
      },
    ],
  },
  {
    path: "/nepse-charts",
    name: "NepalStockExchangeTechnicalCharts",
    component: () =>
      import("pages/TradingviewOverview/TradingViewOverview.vue"),
  },
  {
    path: "/chart",
    name: "NepalStockExchangeTechnicalChart",
    component: () => import("components/Tradingview/TradingView.vue"),
  },
  {
    path: "/",
    component: () => import("layouts/TradeLayout.vue"),
    children: [
      {
        path: "/trader-meet",
        name: "TraderMeet",
        component: () => import("src/pages/TraderMeet.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/chukul-training",
        name: "ChukulTraining",
        component: () => import("src/pages/ChukulTraining/ChukulTraining.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/training",
        name: "Training",
        component: () => import("src/pages/ChukulTraining/TrainingPage.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/form/:id",
        name: "form",
        component: () => import("src/pages/ChukulTraining/FormPage.vue"),
        meta: { requiresAuth: false },
      },
    ],
  },
  {
    path: "/",
    component: () => import("layouts/Theme/ThemeOneLayout.vue"),
    children: [
      {
        path: "/theme-1",
        name: "DashboardMarket",
        component: () => import("src/pages/Theme/MarketSummaryThemePage.vue"),
        meta: { requiresAuth: false },
      },
    ],
  },
  {
    path: "/",
    component: mainLayout(),
    children: [
      {
        path: "/stock-details",
        name: "StockDetails",
        component: () => import("src/pages/Theme/StockDetails.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/demo",
        name: "ArthaSarokar",
        component: () => import("src/pages/Theme/ArthaSarokarDashboard.vue"),
        meta: { requiresAuth: false },
      },

      {
        path: "/broker-theme",
        name: "BrokerTheme",
        component: () => import("src/pages/Theme/BrokerTheme.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/fundamental-theme",
        name: "FundamentalTheme",
        component: () => import("src/pages/Theme/FundamentalTheme.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/charts",
        name: "TradingviewThemeChart",
        component: () => import("src/pages/Theme/TradingviewThemeChart.vue"),
        meta: authRequired(),
      },
    ],
  },
  {
    path: "/:catchAll(.*)*",
    name: "ErrorPage",
    component: () => import("pages/Error404.vue"),
  },
];

export default routes;

function mainLayout() {
  return () => import("layouts/MainLayout.vue");
}

function infoLayout() {
  return () => import("layouts/InfoLayout.vue");
}
function loginPage() {
  return () => import("pages/Login.vue");
}

function authRequired() {
  return {
    requiresAuth: false,
  };
}
function dashboardPage() {
  return () => import("pages/Dashboard.vue");
}

function nepseMarketSummaryPage() {
  return () => import("src/pages/MarketSummary/NepseMarketSummary.vue");
}

function stockProfilePage() {
  return () => import("src/pages/StockProfile.vue");
}
function brokerAnalyticsPage() {
  return () => import("src/pages/BrokerAnalytics.vue");
}
